import React from 'react';
import { styled } from "../../stitches.config";
import RegistrationForm from "../components/RegistrationForm";
import Footer from "../components/Footer"

const RegistrationPage: React.FC = () => {

    return (
        <>
            <Overlay>
                <RegistrationForm />
            </Overlay>
            <Footer />
        </>
    )

};

export default RegistrationPage;

const Overlay = styled("div", {
    position: "relative",
    backgroundColor: "white",
    width: "100%",
    marginLeft: "auto",
    marginRight: "auto",
    minHeight: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "$grayscale10",
    "@bp2": {
        padding: "72px 0 80px 0",
    }
})